<template>
  <div class="retoucher">
    <div class="search-form">
      <div class="left">
        <a-popover>
          <template slot="content">
            <ShortcutDesc/>
          </template>
          <a-button icon="question-circle" shape="round" type="dashed" block>
            操作说明
          </a-button>
        </a-popover>
      </div>
      <div class="right">
        <a-space>
          <a-select v-model="params.retouch" :options="options"/>
          <a-input :allow-clear="true" @keydown.stop placeholder="文件名称" style="width: 140px;"
                   v-model="params.file_name"/>
          <a-input :allow-clear="true" @keydown.stop placeholder="参赛号码" style="width: 110px;" v-model="params.bib_num"/>
          <a-button @click="search" icon="search" type="primary">搜索</a-button>
        </a-space>
      </div>
    </div>
    <PhotoList
        ref="photoList" v-model="selected" :with-tags="true" :with-reward="false"
        :load-func="loadFunc" :album-id="album.id" :query-params="params" :decr-width="25" :decr-height="62"/>
  </div>
</template>

<script>
import api from "../../../../utils/api";
import PhotoList from "./comps/PhotoList";
import ShortcutDesc from "./comps/ShortcutDesc";

export default {
  name: "Retoucher",
  props: ["album", "member"],
  components: {ShortcutDesc, PhotoList},
  data() {
    return {
      params: {
        retouch: 4, file_name: "",
        bib_num: "", member_id: "",
      },
      selected: [],
      loadFunc: api.v1.album.photo.retouchSearch,
      options: [
        {label: "全部", value: 4},
        {label: "未修", value: 2},
        {label: "已修", value: 3},
      ],
    }
  },
  mounted() {
    this.refresh();
  },
  methods: {
    search() {
      this.$refs.photoList.search();
    },
    async refresh() {
      this.$refs.photoList.refresh();
    },
    doUpload() {
      this.$refs.uploadDrawer.open();
    }
  }
}
</script>


<style scoped lang="less">
.retoucher {
  .search-form {
    width: 100%;
    padding: 15px 16px;
    background: #fff;
    z-index: 800;
    position: relative;
    box-shadow: 0 0 5px 5px #dedede;

    .left {
      float: left;
      width: 204px;
      margin-right: 16px;
      padding-right: 16px;
      border-right: 1px #eee solid;
    }
  }
}
</style>
